<template>
  <div>
    <v-card class="tournament-card-preview" elevation="1" v-if="slides.length && (!this.checkIsMobile() && this.checkIsTablet())">
      <div class="tournament-card-header header-live">
        <div class="">
          <span class="label-theme"><v-icon>mdi-trophy-variant</v-icon> {{ $t('featuredTournaments') }}</span>
        </div>
      </div>
      <!--      <v-container>-->
      <v-row class="pl-2 pr-2 pb-2 pt-2">
        <!--<VueSlickCarousel v-bind="settings" v-if="slides.length">-->
        <div class="col-sm-3 slide-image" v-for="(slide, i) in slides" :key="$uuid.v1()" :title="slide.title"
             @click="getDetail({id:slide.id})" v-if="i < 4">
          <v-img :src="slide.image" :title="slide.title" @click="getDetail({id:slide.id})"/>
        </div>
        <!--</VueSlickCarousel>-->
      </v-row>
      <!--      </v-container>-->
    </v-card>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {isMobileOnly} from 'mobile-device-detect';
import {isTablet} from 'mobile-device-detect';
import axios from "axios";
// import _ from "lodash";
import VueSlickCarousel from 'vue-slick-carousel/dist/vue-slick-carousel.umd.min'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import {checkIsMobileDevice, checkIsTabletDevice} from "../../plugins/device-inspector";



export default {
  name: 'ImagesWidget',
  components: {VueSlickCarousel},
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    pathImages: process.env.VUE_APP_URL_CLOUDFRONT,
    cycle: false,
    slides: [],
    /*
    settings: {
      "dots": false,
      "arrows": false,
      "swipeToSlide": false,
      "slidesToShow": 4,
      "slidesToScroll": 1,
      "autoplay": false,
      "autoplaySpeed": 4000,
      "pauseOnDotsHover": true,
      "pauseOnFocus": true,
      "pauseOnHover": true,
      "speed": 1000,
      "cssEase": "linear",
      "responsive": [
        {
          "breakpoint": 1024,
          "settings": {
            "slidesToShow": 3,
            "slidesToScroll": 3,
            "infinite": false,
            "dots": false,
            "arrows": false,
          }
        },
        {
          "breakpoint": 600,
          "settings": {
            "slidesToShow": 2,
            "slidesToScroll": 2,
            "initialSlide": 2,
            "dots": false,
            "arrows": false,
            "swipeToSlide": true,
          }
        },
        {
          "breakpoint": 480,
          "settings": {
            "slidesToShow": 1,
            "slidesToScroll": 1,
            "dots": false,
            "arrows": false,
            "swipeToSlide": true,

          }
        }
      ]
    }*/
  }),

  computed: {
    ...mapGetters({
      'getAuthenticated': 'user/getAuthenticated',
      'getId': 'user/getId',
      'getLogin': 'user/getLogin',
      'getPlatformSettings': 'settings/getPlatformSettings',
      'getBanners': 'settings/getBanners'

    }),

  },
  methods: {
    ...mapActions({
      'setLoadingPreview': 'odds/setLoadingPreview',
      'fetchPreview': 'odds/fetchPreview',
    }),

    checkIsMobile(){
      return checkIsMobileDevice()
    },

    checkIsTablet(){
      return checkIsTabletDevice()
    },

    async getDetail(element) {

      var split = element.id.split("#");
      var typeOdds = 'previewOdds'
      await this.setLoadingPreview({status: true})
      await this.fetchPreview({'tournament': split[0], 'type': typeOdds, 'source': element.id, 'sportId': element.sportId, forceDefaultGameConsole: false});
      setTimeout(
          async () => {
            await this.setLoadingPreview({status: false})
          }, 500);


    },

  },
  watch:{
    getBanners (val) {
      if (val && val.length>1 ) {



        let slides = []
        _.forEach(val, (bann) => {
          if (bann.type == 4) {
            slides.push({"image": bann.image, "id": bann.bet_code + '#prematch', "title": bann.name})
          }
        })

        this.slides = _.shuffle(slides)
      }

    },
  },
  async mounted() {

  },

};
</script>

<style type="text/css">
.slide-image {
  padding: 5px 5px 5px 5px !important;
  cursor: pointer;
}
</style>